import { Plus } from "lucide-react";
import { Link, useNavigate, useParams } from "react-router";
import { usePolicies } from "../api/queries";
import { common } from "../i18n/common";
import { useT } from "../i18n/core";
import { retentionReach, retentionText, scheduleText } from "../lib/policy";
import { ErrorState, LoadingRows, PageHead } from "../ui/Common";
import { policiesMessages } from "./policies.i18n";

export function PoliciesPage() {
  const { orgId = "" } = useParams();
  const navigate = useNavigate();
  const policies = usePolicies(orgId);
  const t = useT(policiesMessages);
  const tc = useT(common);

  return (
    <>
      <PageHead
        title={t.title}
        lede={t.lede}
        actions={<Link className="btn btn-primary" to={`/o/${orgId}/policies/new`}><Plus aria-hidden="true" /> {t.newPolicy}</Link>}
      />
      <section className="panel">
        {policies.isPending ? <LoadingRows /> : policies.isError ? <div className="panel-body"><ErrorState error={policies.error} /></div> : (
          <div className="table-wrap">
            <table className="data">
              <thead><tr><th>{t.colPolicy}</th><th>{t.colSchedule}</th><th>{t.colRpo}</th><th>{t.colRetention}</th><th className="right">{t.colMachines}</th></tr></thead>
              <tbody>
                {policies.data.map((p) => {
                  const href = `/o/${orgId}/policies/${encodeURIComponent(p.id)}`;
                  return (
                    <tr key={p.id} className="clickable" onClick={() => navigate(href)}>
                      <td><Link to={href} onClick={(e) => e.stopPropagation()}><strong>{p.name}</strong></Link></td>
                      <td className="ink-2">{scheduleText(tc, p.schedule)}</td>
                      <td className="num">{p.rpoHours} h</td>
                      <td><div>{retentionText(tc, p.retention)}</div><div className="muted" style={{ fontSize: "var(--fs-12)" }}>{t.reach(retentionReach(tc, p.retention))}</div></td>
                      <td className="right num">{p.machineCount}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </>
  );
}
